// src/router/index.ts
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/HomeView.vue';
import Boozelog from '../views/BoozelogView.vue';
import Privacy from '../views/PrivacyPolicyView.vue';
import Support from '../views/SupportView.vue';
import Contact from '../views/ContactView.vue';
import Decryptor from '../views/DecryptorView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'HomeView',
    component: Home,
  },
  {
    path: '/boozelog',
    name: 'BoozelogView',
    component: Boozelog,
  },
  {
    path: '/boozelog/support',
    name: 'BoozelogSupportView',
    component: Support,
  },
  {
    path: '/boozelog/privacy',
    name: 'BoozelogPrivacyPolicyView',
    component: Privacy,
  },
  {
    path: '/decryptor',
    name: 'DecryptorView',
    component: Decryptor,
  },
  {
    path: '/contact',
    name: 'ContactView',
    component: Contact,
  },
  {
    path: '/privacy',
    redirect: '/boozelog/privacy',
  },
  {
    path: '/support',
    redirect: '/boozelog/support',
  },
  // Redirect unknown routes to Home
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
